import Group from '../entities/Group';
import Memo from '../entities/Memo';

const readMemosRelated = (offset: number, limit: number) => ({
  type: 'READ_MEMOS_RELATED',
  offset,
  limit
});

const successReadMemosRelated = (memos: Memo[]) => ({
  type: 'SUCCESS_READ_MEMOS_RELATED',
  memos
});

const readMemosByGroup = (group: Group, offset: number, limit: number) => ({
  type: 'READ_MEMOS_BY_GROUP',
  group,
  offset,
  limit
});

const truncateMemos = () => ({
  type: 'TRUNCATE_MEMOS'
});

const successReadMemosByGroup = (memos: Memo[]) => ({
  type: 'SUCCESS_READ_MEMOS_BY_GROUP',
  memos
});

const readMemosSearch = (keyword: string, offset: number) => ({
  type: 'READ_MEMOS_SEARCH',
  keyword,
  offset
});

const successReadMemosSearch = (memos: Memo[]) => ({
  type: 'SUCCESS_READ_MEMOS_SEARCH',
  memos
});

const readMemosDiff = () => ({
  type: 'READ_MEMOS_DIFF'
});

const successReadMemosDiff = (memos: Memo[]) => ({
  type: 'SUCCESS_READ_MEMOS_DIFF',
  memos
});

const createMemo = (memo: Memo) => ({
  type: 'CREATE_MEMO',
  memo
});

const successCreateMemo = (memo: Memo) => ({
  type: 'SUCCESS_CREATE_MEMO',
  memo
});

const readMemo = (memo: Memo) => ({
  type: 'READ_MEMO',
  memo
});

const successReadMemo = (memo: Memo) => ({
  type: 'SUCCESS_READ_MEMO',
  memo
});

const updateMemo = (memo: Memo) => ({
  type: 'UPDATE_MEMO',
  memo
});

const successUpdateMemo = (memo: Memo) => ({
  type: 'SUCCESS_UPDATE_MEMO',
  memo
});

const updateMemos = (memos: Memo[]) => ({
  type: 'UPDATE_MEMOS',
  memos
});

const destroyMemo = (memo: Memo) => ({
  type: 'DESTROY_MEMO',
  memo
});

const successDestroyMemo = (memo: Memo) => ({
  type: 'SUCCESS_DESTROY_MEMO',
  memo
});

const readMemosByDeadline = (deadline: number) => ({
  type: 'READ_MEMOS_BY_DEADLINE',
  deadline
});

const successReadMemosByDeadline = (memos: Memo[]) => ({
  type: 'SUCCESS_READ_MEMOS_BY_DEADLINE',
  memos
});

export {
  readMemosByDeadline,
  successReadMemosByDeadline,
  readMemosRelated,
  successReadMemosRelated,
  readMemosByGroup,
  truncateMemos,
  successReadMemosByGroup,
  readMemosSearch,
  successReadMemosSearch,
  readMemosDiff,
  successReadMemosDiff,
  readMemo,
  updateMemos,
  successReadMemo,
  updateMemo,
  successUpdateMemo,
  destroyMemo,
  successDestroyMemo,
  createMemo,
  successCreateMemo
};



// WEBPACK FOOTER //
// ./src/actions/memo.ts